import { checkFetchStatus } from "@stofloos/actions/auth";
import { requestFetching, requestFailure, requestSuccess, setRequestMeta } from "@stofloos/actions/requests";

export const API_HOST = process.env.API_HOST;
export const USE_AUTHENTICATION = process.env.USE_AUTHENTICATION;
if (typeof USE_AUTHENTICATION === "undefined") {
	console.error("USE_AUTHENTICATION is not set, add USE_AUTHENTICATION in index.html");
}

export const SET_OBJECTS = "SET_OBJECTS";
export const SET_OBJECT = "SET_OBJECT";

const fetch_retry = async (url, options, n) => {
	try {
		return await fetch(url, options);
	} catch (err) {
		if (n === 1) throw err;
		return await fetch_retry(url, options, n - 1);
	}
};

function hasRequest(requestId, request) {
	if (requestId === undefined) {
		console.error("No requestId provided");
		return false;
	}

	if (request === undefined) {
		console.error(
			"No request found on requestId " + requestId + ". Call action initRequest from actions/requests.js"
		);
		return false;
	} else {
		return true;
	}
}
const createParams = (url, request, params) => {
	// If params is undefined get from request.
	if (typeof params === "undefined" || !params) {
		let params = {};

		if (request.orderBy) {
			if (request.orderBy.cast) {
				params["order_by"] =
					'{"cast_value": "' +
					request.orderBy.cast +
					'", "field": "' +
					request.orderBy.column +
					'", "direction": "' +
					request.orderBy.direction +
					'"}';
			} else {
				params["order_by"] =
					'{"field": "' + request.orderBy.column + '", "direction": "' + request.orderBy.direction + '"}';
			}
		}
		if (request.page) params["page"] = request.page;
		if (request.pageLimit) params["page_limit"] = request.pageLimit;

		if (request.single) {
			params["single"] = request.single;
		}

		if (request.queryFilters) {
			params["filters"] = JSON.stringify(request.queryFilters);
		}

		url.search = new URLSearchParams(params);
	} else {
		url.search = new URLSearchParams(params);
	}
	return url;
};

// New function with params
export function readObjects(requestId, params, append) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			const request = state.requests[requestId];
			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			const header = {
				"Content-Type": "application/json"
			};

			if (USE_AUTHENTICATION && state.StofwareAuth) {
				header["Authorization"] = "Bearer " + state.StofwareAuth.access_token;
			}

			let url = new URL(`${API_HOST}/` + request.endpoint);

			url = createParams(url, request, params);
			fetch_retry(
				url,
				{
					method: "GET",
					headers: header
				},
				2
			)
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error" || data.status === "warning" || data.status === "fail") {
						reject(data);
					} else {
						if (request.single) {
							dispatch(requestSuccess(requestId));
							resolve(data);
							return dispatch({
								type: SET_OBJECT,
								requestId,
								objects: data,
								append
							});
						} else {
							// Use custom key if present in params otherwise use default objects
							let objects =
								params && params.hasOwnProperty("dataEntry")
									? data[params["dataEntry"]]
									: data.objects
									? data.objects
									: data;
							dispatch(setObjects(requestId, objects, append));
							dispatch(setRequestMeta(requestId, data.pages, data.total_objects));
							dispatch(requestSuccess(requestId));
							resolve(objects);
						}
					}
				})
				.catch(error => dispatch(requestFailure(requestId, error)));
		});
}

export function deleteObjects(requestId, objects) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			const stofwareAuth = state.StofwareAuth;
			const request = state.requests[requestId];

			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			if (stofwareAuth.access_token) {
				let url = new URL(`${API_HOST}/` + request.endpoint);

				fetch(url, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + stofwareAuth.access_token
					},
					body: JSON.stringify(objects)
				})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(response => {
					resolve(response);
					objects.map(object => {
						dispatch(unsetObject(requestId, object.id));
					});
					dispatch(requestSuccess(requestId));
				})
				.catch(error => dispatch(requestFailure(requestId, error)));
			}
		});
}

export function readObject(requestId, objectId, isSingle) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			const stofwareAuth = state.StofwareAuth;
			const request = state.requests[requestId];

			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			const header = {
				"Content-Type": "application/json"
			};

			if (USE_AUTHENTICATION && state.StofwareAuth) {
				header["Authorization"] = "Bearer " + state.StofwareAuth.access_token;
			}

			let url = new URL(`${API_HOST}/` + request.endpoint + "/" + objectId);
			url = createParams(url, request);
			fetch(url, {
				method: "GET",
				headers: header
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
						reject();
					} else {
						dispatch(setObject(requestId, data, isSingle));
						//dispatch(setRequestMeta(requestId, null, null, data.id));
						dispatch(requestSuccess(requestId));
						resolve(data);
					}
				})
				.catch(error => dispatch(requestFailure(requestId, error)));
		});
}

export function deleteObject(requestId, objectId) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			const stofwareAuth = state.StofwareAuth;
			const request = state.requests[requestId];

			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			if (stofwareAuth.access_token) {
				let url = new URL(`${API_HOST}/` + request.endpoint + "/" + objectId);

				fetch(url, {
					method: "DELETE",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + stofwareAuth.access_token
					}
				})
				.then(checkFetchStatus(dispatch, getState))
				.then(response => {
					resolve(response);
					dispatch(unsetObject(requestId, objectId));
					dispatch(setRequestMeta(requestId, null, null, objectId));
					dispatch(requestSuccess(requestId));
				})
				.catch(error => dispatch(requestFailure(error, requestId, objectId)));
			}
		});
}

export function updateObject(requestId, object, isSingle, identifier) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			if (object === undefined) {
				console.error("No object provided");
			}
			const state = getState();
			const stofwareAuth = state.StofwareAuth;
			const request = state.requests[requestId];

			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			const header = {
				"Content-Type": "application/json"
			};

			if (USE_AUTHENTICATION && state.StofwareAuth) {
				header["Authorization"] = "Bearer " + state.StofwareAuth.access_token;
			}

			const endpoint = identifier ? identifier : object.id;
			let url = new URL(`${API_HOST}/` + request.endpoint + "/" + endpoint);
			fetch(url, {
				method: "PUT",
				headers: header,
				body: JSON.stringify(object)
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
						reject(data);
					} else {
						resolve(data);
						dispatch(setObject(requestId, data, isSingle));
						dispatch(setRequestMeta(requestId, null, null, data.id));
						dispatch(requestSuccess(requestId));
					}
				})
				.catch(error => dispatch(requestFailure(error, requestId, object.id)));
		});
}

export function batchObjects(requestId, params) {
	if (params === undefined) {
		console.error("No object provided");
	}

	return (dispatch, getState) => {
		const state = getState();
		const stofwareAuth = state.StofwareAuth;
		const request = state.requests[requestId];

		if (!hasRequest(requestId, request)) {
			return;
		}

		dispatch(requestFetching(requestId));

		if (state.StofwareAuth.access_token) {
			let url = new URL(`${API_HOST}/` + request.endpoint);

			url.search = new URLSearchParams(params);

			fetch(url, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + state.StofwareAuth.access_token
				}
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					if (data.status === "error") {
						reject(data);
					} else {
						dispatch(requestSuccess(requestId));
					}
				})
				.catch(error => dispatch(requestFailure(error, requestId)));
		}
	};
}

export function createObject(requestId, object, isSingle) {
	return (dispatch, getState) =>
		new Promise((resolve, reject) => {
			const state = getState();
			const stofwareAuth = state.StofwareAuth;
			const request = state.requests[requestId];

			if (!hasRequest(requestId, request)) {
				return;
			}

			dispatch(requestFetching(requestId));
			const header = {
				"Content-Type": "application/json"
			};

			if (USE_AUTHENTICATION && state.StofwareAuth) {
				header["Authorization"] = "Bearer " + state.StofwareAuth.access_token;
			}

			let url = new URL(`${API_HOST}/` + request.endpoint);
			fetch(url, {
				method: "POST",
				headers: header,
				body: JSON.stringify(object)
			})
				.then(checkFetchStatus(dispatch, getState))
				.then(res => res.json())
				.then(data => {
					resolve(data);
					dispatch(setObject(requestId, data, isSingle));
					dispatch(setRequestMeta(requestId, null, null, data.id));
					dispatch(requestSuccess(requestId));
				})
				.catch(error => {
					reject(error);
					dispatch(requestFailure(requestId, error));
				});
		});
}

export const setObject = (requestId, object, single) => {
	return (dispatch, getState) => {
		const state = getState();
		if (single) {
			dispatch({
				type: SET_OBJECT,
				requestId,
				objects: object
			});
		} else {
			let objects = state.crud[requestId] ? state.crud[requestId] : [];

			if (objects) {
				if (Array.isArray(objects)) {
					let index = objects.findIndex(function(obj) {
						return obj.id === object.id;
					});
					if (index === -1) {
						objects.push(object);
					} else {
						objects[index] = {...object};
					}
				} else {
					objects[object.id] =  {...object};
				}
			} else {
				objects.push(object);
			}
			dispatch({
				type: SET_OBJECTS,
				requestId,
				objects
			});
		}
	};
};

export const unsetObjects = requestId => {
	return {
		type: SET_OBJECTS,
		requestId,
		objects: [],
		append: false
	};
};

export const unsetObject = (requestId, objectId) => {
	return (dispatch, getState) => {
		const state = getState();
		let objects = state.crud[requestId];
		let id = parseInt(objectId);

		if (Array.isArray(objects)) {
			let index = objects.findIndex(function(obj) {
				return obj.id === id;
			});
			objects.splice(index, 1);
		} else {
			delete objects[id];
		}
		dispatch({
			type: SET_OBJECTS,
			requestId,
			objects
		});
	};
};

export const setObjects = (requestId, objects, append) => {
	if (!requestId) {
		return;
	}

	return {
		type: SET_OBJECTS,
		requestId,
		objects,
		append
	};
};
